/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignInUserRequest
 */
export interface SignInUserRequest {
    /**
     * 
     * @type {string}
     * @memberof SignInUserRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInUserRequest
     */
    password?: string;
}

/**
 * Check if a given object implements the SignInUserRequest interface.
 */
export function instanceOfSignInUserRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SignInUserRequestFromJSON(json: any): SignInUserRequest {
    return SignInUserRequestFromJSONTyped(json, false);
}

export function SignInUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignInUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function SignInUserRequestToJSON(value?: SignInUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
    };
}

